import React, { useState, useEffect } from "react";

import NAV from "../pages/nav";
import PriceScroller from "../components/pricescroll_ver_2";
import MarketHero from "../components/markets/MarketHero";
import MarketSubNav from "../components/markets/MarketSubNav";
import MarketWidgetNav from "../components/markets/MarketWidgetNav";

import MarketSummary from "../components/markets/market_summary";
import MarketSentiment from "../components/markets/market_sentiment_page";
import MacroFI from "../components/markets/macro_fi";
import GlobalMarkets from "../components/markets/global_markets";
import MarketStructure from "../components/markets/derivatives_markets_structure";

import MarketCommentaryBanner from "../components/blog/market_commentary_banner";

import { fetchMarketIndices } from "../api";

export default function MarketPage() {

const [indices, setIndices] = useState([]);

const [activeMainTab, setActiveMainTab] =
    useState("Market Overview");

const [activeWidget, setActiveWidget] =
    useState("Major Indices");

useEffect(() => {

    fetchMarketIndices()
        .then(data => {

            setIndices(data);

        })
        .catch(err =>
            console.error(err)
        );

}, []);

const widgetMap = {

    "Market Overview": [
        "Major Indices",
        "Market Breadth",
        "Sector Performance"
    ],

    "Market Sentiment": [
        "Market Sentiment",
        "Market Volatility",
        "OI Indicators"
    ],

    "Fixed Income & Macro": [
        "Yield Curve",
        "Bond Yields",
        "Interest Rates",
        "Inflation"
    ],

    "Global Markets": [
        "Global Indices",
        "Currencies",
        "Commodities",
        "Global Heatmap",
        "Risk Dashboard",
        "Sov Bonds"
    ],

    "Derivatives Structure": [
        "Open Interest",
        "PCR Analysis",
        "Options Activity",
        "Futures Positioning"
    ]

};

const handleMainTabChange = (tab) => {

    setActiveMainTab(tab);

    const firstWidget =
        widgetMap[tab]?.[0];

    if (firstWidget) {
        setActiveWidget(firstWidget);
    }
};

const renderContent = () => {

    switch (activeMainTab) {

        case "Market Overview":

            return (
                <MarketSummary
                    activeWidget={activeWidget}
                    indices={indices}
                />
            );

        case "Market Sentiment":

            return (
                <MarketSentiment
                    activeWidget={activeWidget}
                />
            );

        case "Fixed Income & Macro":

            return (
                <MacroFI
                    activeWidget={activeWidget}
                />
            );

        case "Global Markets":

            return (
                <GlobalMarkets
                    activeWidget={activeWidget}
                    indices={indices}
                />
            );

        case "Derivatives Structure":

            return (
                <MarketStructure
                    activeWidget={activeWidget}
                />
            );

        default:

            return null;
    }
};

return (

    <div className="min-h-screen bg-slate-50">

        {/* NAVBAR */}

        <NAV activetag="marketpage" />

        {/* HERO */}

        <MarketHero />

        {/* PRICE SCROLLER */}

        <PriceScroller />

        {/* COMMENTARY */}

        {/*<MarketCommentaryBanner />*/}

        {/* PAGE BODY */}

        <div className="max-w-[1700px] mx-auto px-6 py-8">

            {/* TOP HORIZONTAL NAV */}

            <MarketSubNav
                activeTab={activeMainTab}
                setActiveTab={handleMainTabChange}
            />

            {/* MAIN CONTENT AREA */}

            <div className="flex gap-6 mt-8">

                {/* LEFT WIDGET NAV */}

                <MarketWidgetNav
                    items={
                        widgetMap[activeMainTab]
                    }
                    activeItem={
                        activeWidget
                    }
                    onSelect={
                        setActiveWidget
                    }
                />

                {/* RIGHT CONTENT */}

                <div className="flex-1 min-w-0">

                    {renderContent()}

                </div>

            </div>

        </div>

    </div>

);

}
